import React, { useEffect } from 'react';
import { FabNewJourneyContent, ModalOverlay, FabNewJourneyImg } from './styles';
import ModalIMG from '../../assets/images/fabrication-new-journey/modal-onboarding.png';
import { ERoutes } from '../../routes';
import { useHistory } from 'react-router-dom';
import { GmaisModal } from '../GmaisModal';

export interface FabricationNewJourneyModalProps {
  onCloseModal: () => void;
  dontShowThisAgain: () => Promise<void>;
}

export const FabricationNewJourneyModal = ({
  onCloseModal,
  dontShowThisAgain
}: FabricationNewJourneyModalProps) => {
  const history = useHistory();

  function navigateToOrder() {
    history.push(ERoutes.PURCHASE);
  }

  function closeModal() {
    onCloseModal();
  }

  return (
    <GmaisModal
      onDismissModal={closeModal}
      title={'Atualizações nas solicitações de corte e dobra'}
      dontShowAgainCheckBox={true}
      dontShowThisAgain={dontShowThisAgain}
      buttons={{
        action: {
          title: 'Solicitar corte e dobra',
          callback: navigateToOrder
        },
        close: {
          title: 'Fechar',
          callback: closeModal
        }
      }}
    >
      <FabNewJourneyContent>
        <div>
          A partir de hoje, para efetuar suas revisões de pedidos, acesse
          ‘Comprar’, ‘Revisar pedido por histórico’ e depois ‘Revisar pedido’.
          <br />
          <br />
          Os números dos seus novos pedidos e revisões serão atribuídos de forma
          automática e sequencial. A identificação do pedido é um campo aberto
          que permitirá a inclusão de seus dados para controles internos.
          <br />
          <br />
          Em caso de dúvidas, entre em contato com o seu vendedor ou com o
          atendimento técnico.
          <br />
          <br />
          <FabNewJourneyImg src={ModalIMG} />
        </div>
      </FabNewJourneyContent>
    </GmaisModal>
  );
};
